export function useAppEnvironment() {
    const domain = window.location.host.toLowerCase();

    // split the domain to grab the environment and type
    const envParts = domain.split('.');

    // grab the environment type from the domain
    const envType = envParts[1];

    // assign a better name to the local url and prod url
    let activeEnv = envParts[0];

    if (activeEnv === 'localhost') {
        activeEnv = 'local';
    } else if (activeEnv === 'search') {
        activeEnv = 'prod';
    }

    return {
        activeEnv,
        envType,
    };
}
